export default "__VITE_ASSET__Lj1897zX__"